import constate from 'constate';
import { useState } from 'react';

const useDoctor = () => {
  const [selectedDoctor, setSelectedDoctor] = useState<number>(0);
  const [selectedTreatmentIndex, setSelectedTreatmentIndex] = useState<number>(0);

  const resetSelectedDoctorAndTreatmentIndex = () => {
    setSelectedDoctor(0);
    setSelectedTreatmentIndex(0);
  };

  return {
    doctorTotalCount: Infinity, // TODO: change to use query
    selectedDoctor,
    setSelectedDoctor,
    resetSelectedDoctorAndTreatmentIndex,
    selectedTreatmentIndex,
    setSelectedTreatmentIndex
  };
};

export const [DoctorProvider, useDoctorContext] = constate(useDoctor);
